export default class FilterService {

}
